import { CERT_BCORP, CERT_WOMEN_OWNED, GFG_LOGO } from "@/constants/campaignBuilder";

/**
 * Dark GfG footer — logo · mission + Privacy Policy · B-Corp / Women-Owned certs.
 * Tailwind/MUI-only (no imported CSS); the visual is a 1:1 port of the prototype's
 * `.lp-footer*` rules. The recipient flow's single footer — used by the landing and
 * the closing impact reveal so the flow stays on our token-driven Tailwind styling.
 */
export default function RedemptionFooter({ className = "" }: { className?: string }) {
  return (
    <footer
      className={`w-full bg-rodeo-black px-5 pt-10 pb-[max(40px,env(safe-area-inset-bottom))] text-white md:px-6 md:pt-13 md:pb-13 ${className}`.trim()}
    >
      <div className="mx-auto flex max-w-270 flex-col items-start gap-7 md:flex-row md:items-center md:gap-11">
        <a
          className="block shrink-0 self-start leading-0"
          href="https://giftsforgood.com"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="block h-16 w-32 max-w-none filter-[brightness(0)_invert(1)]"
            src={GFG_LOGO}
            alt="Gifts for Good"
          />
        </a>

        <div className="flex min-w-0 flex-col gap-3">
          <p className="m-0 max-w-96 text-balance text-left font-lato text-sm leading-[1.7] text-white/92">
            Gifts for Good is a woman-owned business and Certified B Corporation dedicated to
            empowering the world to help people and the planet through gift giving.
          </p>
          <a
            className="inline-block w-fit font-lato text-[13px] font-semibold text-white underline underline-offset-2 hover:opacity-80 max-md:-my-3 max-md:py-3"
            href="https://giftsforgood.com/pages/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
        </div>

        <div className="ml-auto flex shrink-0 items-center gap-7.5">
          <img
            className="block h-16 w-9.5 max-w-none shrink-0 filter-[brightness(0)_invert(1)]"
            src={CERT_BCORP}
            alt="Certified B Corporation"
          />
          <img
            className="block h-11.5 w-26 max-w-none shrink-0 filter-[brightness(0)_invert(1)]"
            src={CERT_WOMEN_OWNED}
            alt="Women Owned — WBENC certified"
          />
        </div>
      </div>
    </footer>
  );
}
